import "../../assets/css/PlayerList.css";
import { useEffect, useState, useRef } from "react";
import { apiHandler } from "../../assets/api";
import { endpoint } from "../../assets/api/endpoint";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import GameSearchFilter from "../gamesearchfilter/GameSearchFilter";
import PlayerList from "../playerList/PlayerList";
import { IoMdSearch } from "react-icons/io";
import FilterImg from '../../assets/icons/Filter.png';
import { HashLoader } from "react-spinners";
import { FaHeart } from "react-icons/fa";
import { FaUsers } from "react-icons/fa";
import { MdOutlineNotInterested } from "react-icons/md";
import CustomButton from "../../components/CustomButton";
import { MdOutlineSportsTennis } from "react-icons/md";

const FindPlayer = () => {
  const [players, setPlayers] = useState([]);
  const { accessToken, filterUpdating } = useSelector((state) => state.loginInfo);
  const location = useLocation();
  const [selectedPlayers, setSelectedPlayers] = useState([]);
  const [closeFilter, setCloseFilter] = useState(true)
  const [loader, setLoader] = useState(true);
  const [searchQuery, setSearchQuery] = useState("");
  const modalRef = useRef(null);
  // const { socketFindPlayer } = useFindPlayerSocket();
  const [selectedView, setSelectedView] = useState('all');
   const [sportName, setSportName] = useState("");


  useEffect(() => {
    if (location.state?.selectedPlayers) {
      setSelectedPlayers(location.state.selectedPlayers);
    }

    const fetchApi = async () => {
      try {
        setLoader(true);
        const result = await apiHandler({
          url: endpoint.INVITE_GAME ,
          method: "GET",
          authToken: accessToken?.accessToken,
        });
        const response = result.data;
        if (response) {
          setLoader(false);
          setPlayers(response);
        }
      } catch (error) {
        console.error("Error fetching players:", error);
      }
    };

    fetchApi();
  }, [accessToken.accessToken,filterUpdating,closeFilter]);
  // socketFindPlayer

  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => {
    setIsOpen(!isOpen);
  };

  const closeModal = () => {
    setCloseFilter(!closeFilter);
  }

  const onCloseFilterModal = (data) => {
    setIsOpen(!data);
    closeModal(data);
  }

  const onCloseModal = () => {
    setIsOpen(false);
  }

  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      toggleModal();
    }
  };

  useEffect(() => {
    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

   const onSelectedSport = (sportName) => {
    setSportName(sportName)
  }

  return (
    <>
      {!loader ?
        <>
          <div className="d-flex justify-content-center align-items-center" style={{ background: 'rgb(248, 248, 248)' }}>
            <div className="container  find-player-wrapper p-3 p-sm-0 mt-0 mt-sm-2"  >
              <div className='row'>
                <div className="d-sm-flex justify-content-between align-items-center">
                  <div className="d-flex w-100 w-sm-50">
                    <div className=" mt-2 mt-sm-0 d-flex justify-content-between align-items-center w-100">
                      <CustomButton buttonText={"All Players"} className={`favorite-plyer-btn ${selectedView === 'all' ? 'active' : ''}`} icon={ <FaUsers className="me-2"/>}  onClick={() => setSelectedView('all')} />
                      {sportName && <h6 style={{ color: 'rgb(31, 32, 36)' , fontWeight: '700', fontSize: '15px' }}> <MdOutlineSportsTennis className="fs-6"/> {sportName}</h6>}
                    </div>
                  </div>
                  <div className=" mb-1 mt-3 m-sm-2">
                    <div className="d-sm-flex justify-content-between player-list-search-bar">
                      <div className="d-flex">
                        <CustomButton buttonText={"Favorite Player"}  className={`favorite-plyer-btn ${selectedView === 'favorite' ? 'active' : ''}`} icon={<FaHeart className="me-2" />} onClick={() => setSelectedView('favorite')} />
                        <CustomButton buttonText={"Excluded Player"}  className={`favorite-plyer-btn ${selectedView === 'excluded' ? 'active' : ''}`} icon={ <MdOutlineNotInterested className="me-1"  />}  onClick={() => setSelectedView('excluded')} />
                      </div>
                      <div className="d-flex justify-content-between mt-3 mt-sm-0 mb-3 mb-sm-0">
                      <div className="search-bar d-flex justify-content-end">
                        <IoMdSearch className="fs-2 me-2" />
                        <input
                          type="text"
                          placeholder="Search Players..."
                          className="search-input"
                          value={searchQuery}
                          onChange={(e) => setSearchQuery(e.target.value)}
                        />
                      </div>
                      <div>
                        <img src={FilterImg} onClick={toggleModal} style={{ cursor: 'pointer' }} />
                      </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  {(() => {
                    const filteredPreferredUsers = players?.preferredUsers?.filter(player =>
                      player.name?.toLowerCase().includes(searchQuery.toLowerCase())
                    ) || [];

                    const filteredExcludedUsers = players?.excludedUsers?.filter(player =>
                      player.name?.toLowerCase().includes(searchQuery.toLowerCase())
                    ) || [];

                    const filteredAllUsers = players?.allUsers?.filter(player =>
                      player.name?.toLowerCase().includes(searchQuery.toLowerCase())
                    ) || [];

                    const hasResults =
                      filteredPreferredUsers.length > 0 ||
                      filteredExcludedUsers.length > 0 ||
                      filteredAllUsers.length > 0;

                    return hasResults ? (
                      <div>
                        {selectedView === 'favorite' && filteredPreferredUsers.length > 0 && (
                          <>
                            <PlayerList
                              stringerPlayer={filteredPreferredUsers}
                              closeModal={closeModal}
                              disableButton="preferredUser"
                            />
                          </>
                        )}

                        {selectedView === 'excluded' && filteredExcludedUsers.length > 0 && (
                          <>
                            <PlayerList
                              stringerPlayer={filteredExcludedUsers}
                              closeModal={closeModal}
                              disableButton="exludedUser"
                            />
                          </>
                        )}

                        {selectedView === 'all' && filteredAllUsers.length > 0 && (
                          <>
                            <PlayerList
                              stringerPlayer={filteredAllUsers}
                              closeModal={closeModal}
                            />
                          </>
                        )}
                      </div>

                    ) : (
                      <div className="d-flex align-items-center justify-content-center" style={{ height: '50vh' }} >
                        <h3 className="text-center py-3" style={{ fontWeight: '600', color: 'rgba(33, 37, 41, 0.75)' }}>No Players Found</h3>
                      </div>
                    );
                  })()}
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className={`modal-overlay ${isOpen ? "open" : "closeModal"}`}>
              <div ref={modalRef} className="modal-content overflow-x-auto">
                <GameSearchFilter
                  onCloseFilterModal={onCloseFilterModal}
                  onCloseModal= { onCloseModal }
                    onSelectedSport={onSelectedSport}
                />
              </div>
            </div>
          </div>
        </>
        :
        <div className="d-flex align-items-center justify-content-center" style={{ height: '75vh' }}>
          < HashLoader color="#e48181" />
        </div>
      }
    </>
  );
};

export default FindPlayer;
